import SelectedList from "./Base/SelectedList";
import GroupByList from "./Base/GroupByList";

function createFilter(type, fields) {
  return {
    value: [],
    type,
    fields,
    logic: "or", //任意field满足一个即可
  };
}

class IndexStore {
  debug = process.env.VUE_APP_DEV_DOMAIN === "true";

  tables = [];

  state = {
    Vin: "",
    CarTypeName: "",
    VehicleTypeId: "", //车型Id
    list: [],
    filters: [], //所有条件均要满足
    brandList: [],
    categoryList: [],
    selectBrandsCache: [],//保存这次筛选的品牌，用于切换仓库的时候记录
    selectCategorysCache: [],//保存这次筛选的分类，用于切换仓库的时候记录
    CompanyName: "",
    EmployeeName: "",
    EmployeePhone: "",

    wareHouseType: 0,//1:显示默认仓库库存.2:不显示库存,3:允许仓库选择4:显示所有仓库库存合计
    warehouse_val: '',//仓库下拉框选中值
    sortBar: [
      { text: "按价格排序", field: "Price", type:"Number" },
      { text: "按品牌排序", field: "BrandName" , type:"String"},
      { text: "按库存排序", field: "StoreNum", type:"Number" },
    ],
    warehouseList: [],//下拉仓库列表
    MallActivityManagementlist: [],//首页活动列表
    toVinSearchPage:true, //是否跳转到vin码查询页面
    wareHouseValue: 0 // 1是智能仓
  };

  constructor() {
    this.keywordFilter = createFilter("like", ["ProductName", "Model", "BrandName", "ClassificationName"]);
    this.brandFilter = createFilter("eq", ["BrandName"]);
    this.categoryFilter = createFilter("eq", ["ClassificationName"]);

    this.state.filters = [this.keywordFilter, this.brandFilter, this.categoryFilter];

    this.selectedList = new SelectedList({ list: this.state.list, checkField: "check" });
  }

  initList(list) {
    if (this.debug) console.log("初始化产品列表数据");

    let brandMap = new Map();
    let categoryMap = new Map();
    this.state.list = list.map((it) => {
      if (!brandMap.has(it.BrandName)) {
        brandMap.set(it.BrandName, {
          text: it.BrandName,
          categorySet: new Set(),
          selected: false,
        });
      }

      if (!categoryMap.has(it.ClassificationName)) {
        categoryMap.set(it.ClassificationName, {
          text: it.ClassificationName,
          brandSet: new Set(),
          selected: false,
        });
      }

      brandMap.get(it.BrandName).categorySet.add(it.ClassificationName);
      categoryMap.get(it.ClassificationName).brandSet.add(it.BrandName);

      // it.isShow = true;
      return it;
    });

    this.selectedList.updateList(this.state.list);

    this.state.brandList = [...brandMap.values()];
    this.state.categoryList = [...categoryMap.values()];
  }

  setVehicleTypeId(VehicleTypeId) {
    if (this.debug) console.log("设置车型Id");
    this.state.VehicleTypeId = VehicleTypeId;
  }

  setState(key, val) {
    this.state[key] = val;
  }
  setKeyword(keyword) {
    if (this.debug) console.log("设置搜索关键字");
    this.keywordFilter.value = keyword.trim() == "" ? [] : [keyword.trim()];

    return this;
  }

  //设置品牌
  setBrandList(list) {
    if (this.debug) console.log("设置搜索品牌列表");

    this.brandFilter.value = list;
    return this;
  }

  //设置分类
  setClassList(list) {
    if (this.debug) console.log("设置搜索分类列表");

    this.categoryFilter.value = list;
    return this;
  }

  search() {
    if (this.debug) console.log("搜索");
    let { list } = this.state;

    list.forEach((row) => {
      //列表 循环
      row.check = false;
      //console.log('filters',this.state.filters);
      let filters = this.state.filters.filter((it) => it.value.length > 0);
      let findStatus = true;

      for (const filter of filters) {
        //过滤器 循环

        let { type, fields } = filter;
        let conditions = filter.value;

        if (type == "eq") {
          /** 需要满足所有filter条件 */
          findStatus =
            findStatus &&
            fields.some((field) => {
              //满足一个条件即可
              let value = row[field];
              if (conditions.includes(value)) {
                return true;
              }
            });
        } else if (type == "like") {
          /** 需要满足所有filter条件 */
          findStatus =
            findStatus &&
            fields.some((field) => {
              //满足一个条件即可
              let value = row[field];
              if (
                conditions.some(
                  (it) =>
                    value
                      .toString()
                      .toLowerCase()
                      .indexOf(it.toLowerCase()) !== -1
                )
              ) {
                return true;
              }
            });
        }

        if (!findStatus) {
          break;
        }
      }
      console.log(findStatus);
      row.isShow = findStatus;
    });
  }

  _filterRun(filter) { }

  sort({field, type}, orderBy) {

    if (this.debug) console.log("产品列表排序", field, orderBy);

    console.log();
    let { list } = this.state;

    if(type =="String"){
      if (orderBy === "asc") {
        list.sort((a, b) => String(a[field]).localeCompare(String(b[field]), "zh-CN")); //升序
      } else {
        list.sort((a, b) => String(b[field]).localeCompare(String(a[field]), "zh-CN")); //降序
      }
    }else if( type="Number"){
      if (orderBy === "asc") {
        list.sort((a, b) => parseFloat(a[field]) - parseFloat(b[field])); //升序
      } else {
        list.sort((a, b) => parseFloat(b[field]) - parseFloat(a[field])); //降序
      }
    }
  
  }

  //设置车型Vin
  setVin(text) {
    this.state.Vin = text;
  }

  //设置车型名称
  setCarTypeName(text) {
    this.state.CarTypeName = text;
  }
  
  selectedAll() {
    return this.selectedList.selectedAll.apply(this.selectedList, arguments);
  }

  initTablesGroupBy({ list, field, tableConfig }) {
    let groupByList = new GroupByList({ list });
    let groupByResult = groupByList.groupBy(field);

    this.tables = groupByResult.map((it) => {
      return Object.assign(
        {
          title: it.name,
          rows: it.list,
        },
        tableConfig
      );
    });
  }
}
export default new IndexStore();
